/* eslint-disable */
import React, { useEffect, useRef, useState, forwardRef } from 'react';
import { makeStyles } from '@mui/styles';
import { Link as RouterLink, useSearchParams, useLocation, useNavigate } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Button,
  Typography,
  Container,
  Card,
  Grid,
  Slide,
  Stack,
  Tab,
  Skeleton,
  FormControl,
  Select,
  MenuItem,
  Snackbar,
  Alert,
  Switch,
  Tooltip
} from '@mui/material';

import { TabContext, TabList, TabPanel } from '@mui/lab';
import { EndTripModal, LockHistory } from '../components/_dashboard/smartlock';
import Page from '../components/Page';
import { fToNow } from '../utils/formatTime';
import BoltTwoToneIcon from '@mui/icons-material/BoltTwoTone';
import CircleIcon from '@mui/icons-material/Circle';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ConfirmAlertDialog from '../components/ConfirmDialog';
import {
  GetTripData,
  GetTripEvents,
  StartTripById,
  TrackingTripLocationData,
  UpdateGeoFenceStatus
} from '../network/Trip';
import { fNumber } from '../utils/formatNumber';
import MapPathView from '../components/MapPathView';
import { getEta, HeaderHeight, tripStatus } from '../Constants';
import UnlockDeviceModal from '../components/_dashboard/smartlock/UnlockDeviceModal';
import { getColorAccordingBattery, truncateText } from '../utils/Parser';
import DriverDetailModal from '../components/_dashboard/smartlock/DriverDetailModal';
import { APP_CONSTANTS, SMART_LOCK_API_ENDPOINTS } from '../URLConstants';
import useFeatures from '../components/customContextProviders/FeatureContext';
import Header from '../components/navbar/Header';
import { getCognitoCredentials } from '../utils/IOTconnection';
import { throttle } from 'lodash';
import AWSIoTData from 'aws-iot-device-sdk';
import { useAuth } from '../components/customContextProviders/AuthContext';
import LocationTripHistory from '../components/_dashboard/smartlock/LocationTripHistory';
import { encryptStorage } from '../CustomStorage';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// ----------------------------------------------------------------------
const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)'
    }
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff'
      }
    }
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200
    })
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box'
  }
}));

const useStyles = makeStyles((theme) => ({
  labelTypography: {
    color: '#6F6F6F',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '25px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  },
  valueTypography: {
    color: '#171D40',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '25px',
    textTransform: 'capitalize',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  },
  locationHistoryTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },

  locationHistoryAddress: {
    fontSize: 12,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10
    }
  },
  callButtonOnMap: {
    position: 'absolute',
    // top: '70%',
    right: '3%',
    backgroundColor: 'white',
    color: 'black',
    bottom: '15%'
  },
  lockedStatusOnMap: {
    top: '75%',
    left: '35%',
    position: 'absolute',
    background: 'white',
    padding: '5px',
    color: 'black',
    fontSize: 14,
    borderRadius: '5px 5px'
  },
  reportButtonOnMap: {
    position: 'absolute',
    top: '70%',
    left: '3%',
    backgroundColor: 'white',
    color: 'black'
  },
  topLeftStackOnMap: {
    position: 'absolute',
    top: '27%',
    left: '3%',
    backgroundColor: 'white !important',
    color: 'black !important'
  },
  topRightStackOnMap: {
    position: 'absolute',
    top: '27%',
    right: '3%',
    backgroundColor: 'white !important',
    color: 'black !important'
  },
  notFoundContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function TripDetails() {
  const { sessionCognitoData } = useAuth();
  const isAuthenticated = encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS);

  const location = useLocation({});
  const classes = useStyles();
  const feature = useFeatures();

  let mqttClient = null;
  let isMqttClientConnected = false;

  const [open, setOpen] = useState(false);
  const [deviceUnlockDialogVisibility, setDeviceUnlockDialogVisibility] = useState(false);
  const [deviceUnlockDialogData, setDeviceUnlockDialogData] = useState({
    title: '',
    message: '',
    icon: '',
    visibility: false
  });
  const [isEndTripModalVisible, setEndTripModalVisible] = useState(false);
  const [eventLoader, setEventLoader] = useState(false);
  const [selectedTab, setSelectedTab] = useState('location');
  const [tripEventData, setTripEventData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [tripDetailsData, setTripDetailsData] = useState({});
  const [loader, setLoader] = useState(false);
  const [deviceData, setDeviceData] = useState([]);
  const [filterDeviceData, setFilterDeviceData] = useState('');
  const [unloadModalIsOpen, setUnlockModalIsOpen] = useState(false);
  const [isDriverDetailModal, setIsDriverDetailModal] = useState(false);
  const [driverDetails, setDriverDetails] = useState(null);
  const [deviceLiveData, setDeviceLiveData] = useState([]);
  const [geoFencingEnable, setGeoFencingEnable] = useState(tripDetailsData?.data?.geoFenceStatus);
  const [allDeviceLocationData, setAllDeviceLocationData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openConfirmAlertDialog, setOpenConfirmAlertDialog] = useState(false);
  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: '',
    title: '',
    positiveBtnLable: '',
    negativeBtnLabel: ''
  });

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'bottom';
  const horizontal = 'left';

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertMetas({ ...alertMetas, snackBarOpened: false });
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setPageNumber(0);
    setDataPerPage(10);
  };

  const getTripData = async (tripId) => {
    try {
      setLoader(true);
      const res = await GetTripData(tripId);
      setTripDetailsData(res?.data);
      setDeviceData(res?.data?.devices);
    } catch (err) {
      console.log('Error fetching trip data:', err);
    } finally {
      setLoader(false);
    }
  };

  const getTripAllEvents = async (tripId, deviceId, pageNumber, dataPerPage, selectedTab) => {
    try {
      setEventLoader(true);
      const response = await GetTripEvents(
        tripId,
        deviceId,
        pageNumber + 1,
        dataPerPage,
        selectedTab
      );
      setTripEventData(response?.data || []);
      setEventLoader(false);
    } catch (error) {
      console.error('Error fetching location data:', error);
      setTripEventData([]);
    } finally {
      setEventLoader(false);
    }
  };

  const handleAction = (msg, action) => {
    getTripData(location?.state?.tripData?.id);
  };

  const handleDeviceFilter = (event) => {
    setFilterDeviceData(event?.target?.value);
  };

  const driverDetailHandler = (data) => {
    setDriverDetails({
      name: data?.data?.driverName,
      phone: data?.data?.driverPhone,
      image: data?.data?.driverImage
    });
    setIsDriverDetailModal(true);
  };

  const handleTripStart = async (id, msg) => {
    const payload = {
      note: msg
    };

    try {
      const res = await StartTripById(id, payload);
      setAlertMetas({
        ...alertMetas,
        severity: 'success',
        snackBarOpened: true,
        msg: 'Trip Started Successfully!'
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
      handleAction();
    } catch (err) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: err?.response?.data?.message
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  const showDialogBox = () => {
    setConfirmAlertDialogMetas({
      ...confirmAlertDialogMetas,
      message: `Are you sure you want to ${geoFencingEnable ? 'disable' : 'enable'} geofence?`,
      title: 'Geofence',
      positiveBtnLable: 'Confirm',
      negativeBtnLabel: 'Cancel'
    });
    setOpenConfirmAlertDialog(true);
  };

  const handleGeoFencing = async () => {
    setIsLoading(true);
    const tripId = tripDetailsData?.data?.id;

    if (!tripId) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: 'Invalid trip ID. Please try again.'
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
      setIsLoading(false);
      return;
    }

    try {
      const res = await UpdateGeoFenceStatus(tripId, !geoFencingEnable);

      if (res) {
        const updatedStatus = res?.data?.data?.geoFenceStatus;
        setGeoFencingEnable(updatedStatus);
        setAlertMetas({
          ...alertMetas,
          severity: 'success',
          snackBarOpened: true,
          msg: `Geofence ${updatedStatus ? 'enabled' : 'disabled'} successfully!`
        });
      }
    } catch (error) {
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message || 'An error occurred. Please try again.'
      });
    } finally {
      setOpenConfirmAlertDialog(false);
      setIsLoading(false);
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  const transformDataToCoordinates = (data) => {
    if (!data || typeof data !== 'object') {
      console.error('Invalid data format:', data);
      return [];
    }

    return Object.keys(data)?.flatMap((deviceImei) =>
      data[deviceImei]?.map((location) => ({
        location_lat: parseFloat(location?.location_lat),
        location_lng: parseFloat(location?.location_lng),
        deviceImei
      }))
    );
  };

  const getAllLocationData = async (tripId) => {
    try {
      const response = await TrackingTripLocationData(tripId);
      const transformedData = transformDataToCoordinates(response?.data?.data) || [];
      setAllDeviceLocationData(transformedData);
    } catch (error) {
      console.error('Error fetching location data:', error);
      setAllDeviceLocationData([]);
    }
  };

  useEffect(() => {
    if (tripDetailsData?.data) {
      setGeoFencingEnable(tripDetailsData?.data?.geoFenceStatus);
    }
  }, [tripDetailsData?.data]);

  useEffect(() => {
    const tripId = location?.state?.tripData?.id;
    if (tripId) {
      getTripData(tripId);
      getAllLocationData(tripId);
    }
  }, [location?.state?.tripData?.id]);

  useEffect(() => {
    if (deviceData) {
      setFilterDeviceData(deviceData[0]?.id);
    }
  }, [deviceData]);

  useEffect(() => {
    const tripId = location?.state?.tripData?.id;
    if (filterDeviceData) {
      getTripAllEvents(tripId, filterDeviceData, pageNumber, dataPerPage, selectedTab);
    }
  }, [selectedTab, filterDeviceData, pageNumber, dataPerPage]);

  const initializeMQTT = async () => {
    try {
      const credentials = await getCognitoCredentials(sessionCognitoData);
      mqttClient = AWSIoTData.device({
        region: process.env.REACT_APP_REGION,
        host: process.env.REACT_APP_AWS_IOT_ENDPOINT_HOST,
        clientId: credentials?.identityId,
        protocol: 'wss',
        maximumReconnectTimeMs: 30000,
        autoResubscribe: false,
        offlineQueueDropBehavior: 'newest',
        clean: true,
        debug: false,
        accessKeyId: credentials?.accessKeyId,
        secretKey: credentials?.secretKey,
        sessionToken: credentials?.sessionToken
      });

      mqttClient.on('connect', () => {
        console.log('MQTT connected');
        isMqttClientConnected = true;

        // Subscribe to topics for all devices
        tripDetailsData?.devices?.forEach((item) => {
          const deviceImei = item?.device_settings?.imei;
          if (deviceImei) {
            const topic = `topic/1/client/${deviceImei}/subscribe`;
            mqttClient.subscribe(topic, (err) => {
              if (err) console.error('Error subscribing to topic:', err);
              else console.log(`Subscribed to topic: ${topic}`);
            });
          }
        });
      });

      const updateLiveData = throttle((newMessage, imei) => {
        setDeviceLiveData((prevData) => {
          const existingIndex = prevData?.findIndex((item) => item?.body?.lock?.id === imei);

          if (existingIndex !== -1) {
            const updatedData = [...prevData];
            if (JSON.stringify(updatedData[existingIndex]) !== JSON.stringify(newMessage)) {
              updatedData[existingIndex] = newMessage;
            }
            return updatedData;
          }

          return [...prevData, newMessage];
        });
      }, 1000);

      mqttClient.on('message', (topic, message) => {
        try {
          const jsonMessage = JSON.parse(message.toString());
          const deviceImei = topic.split('/')[3];

          if (deviceImei && !Array.isArray(jsonMessage)) {
            updateLiveData(jsonMessage, deviceImei);
          }
        } catch (err) {
          console.error('Error parsing MQTT message:', err);
        }
      });

      mqttClient.on('error', (err) => {
        console.error('MQTT Error:', err);
        isMqttClientConnected = false;
      });

      mqttClient.on('close', () => {
        console.log('MQTT connection closed');
        isMqttClientConnected = false;
      });

      mqttClient.on('offline', () => {
        console.log('MQTT offline');
      });

      mqttClient.on('reconnect', () => {
        console.log('MQTT reconnecting');
      });

      return () => {
        // Cleanup on component unmount
        if (mqttClient && isMqttClientConnected) {
          mqttClient.end(true);
          console.log('MQTT client disconnected');
        }
      };
    } catch (err) {
      console.error('Error initializing MQTT:', err);
    }
  };

  const disConnectMqtt = () => {
    if (mqttClient !== null && mqttClient !== undefined) {
      console.log('closing_mqtt_connection', mqttClient);
      mqttClient.end(true, null, (err) => {
        console.log('closed_mqtt', err);
      });
      mqttClient = null;
      isMqttClientConnected = false;
    }
  };

  useEffect(() => {
    const cleanupMqtt = async () => {
      if (isAuthenticated) {
        await initializeMQTT();
      } else {
        disConnectMqtt();
      }
    };

    cleanupMqtt();

    return () => {
      disConnectMqtt();
    };
  }, [tripDetailsData, setDeviceLiveData, isAuthenticated]);

  return (
    <Page title="Trip Details">
      <Header
        onOpenSidebar={() => setOpen(true)}
        // handleSearch={handleTripSearch}
        // handleSubmit={searchTrip}
        name="Trip Detail"
        showSearch={false}
      />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Container
        maxWidth="false"
        disableGutters
        sx={{ padding: 0, height: `calc(100vh - ${HeaderHeight + 40}px)` }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: '10px',
            height: '50px'
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 18 },
              fontWeight: 900,
              fontStyle: 'bold',
              textTransform: 'capitalize'
            }}
          >
            Trip Name - {tripDetailsData?.data?.name}
          </Typography>
        </Box>
        <Box sx={{ height: `calc(100vh - ${HeaderHeight + 50 + 20}px)` }}>
          <Grid container spacing={2} sx={{ height: '100%' }}>
            <Grid
              item
              xs={12}
              md={7}
              // sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
            >
              {loader ? (
                <Skeleton
                  variant="rectangular"
                  sx={{ borderRadius: '20px', height: '100%', flexGrow: 1 }}
                />
              ) : (
                <Card
                  sx={{
                    height: `calc(100vh - ${HeaderHeight + 50 + 50}px)`,
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Box sx={{ height: '100%' }}>
                    <Grid container spacing={1} sx={{ p: 2 }}>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.labelTypography}> Device Name</Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        {tripDetailsData?.devices?.length === 1 ? (
                          <Typography className={classes.valueTypography}>
                            {tripDetailsData?.devices[0]?.name}
                          </Typography>
                        ) : (
                          <Typography className={classes.valueTypography}>
                            {tripDetailsData?.devices?.length} SmartLocks
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.labelTypography}>Route Name</Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.valueTypography} sx={{ cursor: 'pointer' }}>
                          <Tooltip placement="top" title={tripDetailsData?.data?.route?.name || ''}>
                            <span>
                              {truncateText(tripDetailsData?.data?.route?.name, 12) ||
                                'No route name'}
                            </span>
                          </Tooltip>
                        </Typography>
                      </Grid>

                      <Grid item xs={6} md={3}>
                        <Typography className={classes.labelTypography}>Vehicle Name</Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.valueTypography}>
                          {tripDetailsData?.data?.vehicle?.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.labelTypography}>Vehicle Number</Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.valueTypography}>
                          {tripDetailsData?.data?.vehicle?.registrationNo}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.labelTypography}>ETA</Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.valueTypography}>
                          {getEta(tripDetailsData?.data?.route?.eta)}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.labelTypography}>ATD</Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography className={classes.valueTypography}>
                          {fToNow(tripDetailsData?.data?.startTime)}
                        </Typography>
                      </Grid>
                      {feature?.trip?.geofence &&
                        tripDetailsData?.data?.status?.toUpperCase() !== 'COMPLETED' && (
                          <>
                            <Grid item xs={6} md={3}>
                              <Typography className={classes.labelTypography}>GeoFence</Typography>
                            </Grid>
                            <Grid item xs={6} md={3}>
                              <CustomSwitch
                                // onChange={showDialogBox}
                                onClick={(e) => {
                                  e.preventDefault();
                                  showDialogBox();
                                }}
                                checked={geoFencingEnable}
                                inputProps={{ 'aria-label': 'ant design' }}
                              />
                            </Grid>
                          </>
                        )}
                    </Grid>

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'calc(100% - 150px)'
                      }}
                    >
                      <Box sx={{ width: '100%', flexGrow: 1 }}>
                        <MapPathView
                          tripData={tripDetailsData}
                          markerPoint={deviceLiveData}
                          locationPoints={allDeviceLocationData}
                        />
                      </Box>

                      <Button
                        onClick={() => driverDetailHandler(tripDetailsData)}
                        variant="contained"
                        size="small"
                        className={classes?.callButtonOnMap}
                        startIcon={<PersonOutlineOutlinedIcon />}
                      >
                        Driver Details
                      </Button>
                    </Box>
                  </Box>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-end"
                    spacing={2}
                    sx={{ p: 2, marginTop: 'auto' }}
                  >
                    {feature?.trip?.unlockDevice &&
                      tripDetailsData?.data?.status?.toUpperCase() !==
                        tripStatus.TRIP_COMPLETED && (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => setUnlockModalIsOpen(true)}
                        >
                          Unlock
                        </Button>
                      )}
                    {feature?.trip?.tripStatus && (
                      <>
                        {tripDetailsData?.data?.status?.toUpperCase() ===
                          tripStatus.TRIP_STARTED && (
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ mr: 2 }}
                            onClick={() => setEndTripModalVisible(true)}
                          >
                            End Trip
                          </Button>
                        )}
                        {tripDetailsData?.data?.status?.toUpperCase() ===
                          tripStatus.TRIP_SCHEDULED && (
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ mr: 2 }}
                            onClick={() =>
                              handleTripStart(tripDetailsData?.data?.id, 'Trip started')
                            }
                          >
                            Start Trip
                          </Button>
                        )}
                      </>
                    )}
                  </Stack>
                </Card>
              )}
            </Grid>
            <Grid item xs={12} md={5}>
              <Card sx={{ height: `calc(100vh - ${HeaderHeight + 50 + 50}px)`, overflow: 'auto' }}>
                <Box
                  sx={{
                    width: '100%',
                    typography: 'body1',
                    height: '100%'
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-start"
                    padding="20px 20px 10px 20px"
                  >
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <Select
                        id="device_filter"
                        value={filterDeviceData}
                        onChange={handleDeviceFilter}
                        IconComponent={ExpandMoreIcon}
                        sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: '500' }}
                      >
                        {deviceData?.map((item) => (
                          <MenuItem key={item?.id} value={item?.id} className={classes.menuItem}>
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: '10px'
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  gap: '5px'
                                }}
                              >
                                <CircleIcon
                                  sx={{
                                    width: { xs: '8px', sm: '10px' },
                                    height: { xs: '8px', sm: '10px' },
                                    fontSize: { xs: '12px', sm: '14px' },
                                    color:
                                      item?.deviceLiveStatus?.toUpperCase() === 'ONLINE'
                                        ? '#0DA626'
                                        : '#C30A0A'
                                  }}
                                />{' '}
                                <Typography
                                  sx={{
                                    fontSize: { xs: '12px', sm: '14px' }
                                  }}
                                >
                                  {item?.name}
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  gap: '5px'
                                }}
                              >
                                {item?.latestEvent?.battery_charging ? (
                                  <BoltTwoToneIcon
                                    fontSize="small"
                                    sx={{
                                      color: getColorAccordingBattery(
                                        item?.latestEvent?.battery_remaining
                                      )
                                    }}
                                  />
                                ) : (
                                  <CircleIcon
                                    sx={{
                                      width: { xs: '8px', sm: '10px' },
                                      height: { xs: '8px', sm: '10px' },
                                      color: getColorAccordingBattery(
                                        item?.latestEvent?.battery_remaining
                                      )
                                    }}
                                  />
                                )}
                                <Typography
                                  sx={{
                                    fontSize: { xs: '12px', sm: '14px' }
                                  }}
                                >
                                  {fNumber(item?.latestEvent?.battery_remaining)} %
                                </Typography>
                              </Box>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Stack>

                  <TabContext value={selectedTab} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box
                      sx={{
                        borderBottom: 1,
                        borderColor: 'divider'
                      }}
                    >
                      <TabList
                        variant="fullWidth"
                        onChange={handleTabChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Location Timeline" value="location" />
                        <Tab label="Lock History" value="alert" />
                      </TabList>
                    </Box>
                    <TabPanel value="location">
                      <LocationTripHistory
                        loader={eventLoader}
                        locationData={tripEventData}
                        setLocationPageNumber={setPageNumber}
                        locationPageNumber={pageNumber}
                        setDataPerPage={setDataPerPage}
                        dataPerPage={dataPerPage}
                      />
                    </TabPanel>

                    <TabPanel value="alert">
                      <LockHistory
                        tripHistoryData={tripEventData}
                        loader={eventLoader}
                        setPageNumber={setPageNumber}
                        pageNumber={pageNumber}
                        setDataPerPage={setDataPerPage}
                        dataPerPage={dataPerPage}
                      />
                    </TabPanel>
                  </TabContext>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <EndTripModal
        tripId={tripDetailsData?.data?.id}
        openAssignedModal={isEndTripModalVisible}
        handleClose={() => setEndTripModalVisible(false)}
        onAction={(msg, action) => handleAction(msg, action)}
        setAlertMetas={setAlertMetas}
        alertMetas={alertMetas}
      />
      <UnlockDeviceModal
        openAssignedModal={unloadModalIsOpen}
        setUnlockModalIsOpen={setUnlockModalIsOpen}
        devices={deviceData}
      />
      <DriverDetailModal
        isOpen={isDriverDetailModal}
        onClose={() => setIsDriverDetailModal(false)}
        driverData={driverDetails}
      />
      <ConfirmAlertDialog
        openConfirmAlertDialog={openConfirmAlertDialog}
        message={confirmAlertDialogMetas?.message}
        title={confirmAlertDialogMetas?.title}
        positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
        negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLabel}
        handleClose={() => setOpenConfirmAlertDialog(false)}
        handlePositiveClose={handleGeoFencing}
        handleNegativeClose={() => setOpenConfirmAlertDialog(false)}
        isLoading={isLoading}
      />
    </Page>
  );
}
